module.exports = __webpack_public_path__ + "static/media/blog-13.99cb5833.svg";